import React from 'react';

export default function SectionTag({ label, icon, inverted = false }) {
  if (inverted) {
    return (
      <div
        className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4"
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: '1px solid rgba(255,255,255,0.5)',
        }}
      >
        {icon
          ? <span style={{ color: '#ffffff', fontSize: '13px' }}>{icon}</span>
          : <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#ffffff', display: 'inline-block' }} />
        }
        <span style={{ color: '#ffffff', fontFamily: 'popinsMedium', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          {label}
        </span>
      </div>
    );
  }

  return (
    <div
      className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4"
      style={{
        background: 'rgba(63,196,227,0.1)',
        border: '1px solid rgba(63,196,227,0.3)',
      }}
    >
      {icon
        ? <span style={{ color: '#3FC4E3', fontSize: '13px' }}>{icon}</span>
        : <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#3FC4E3', display: 'inline-block' }} />
      }
      <span style={{ color: '#3FC4E3', fontFamily: 'popinsMedium', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
        {label}
      </span>
    </div>
  );
}
